import { OrderStatus, OrderStatusLabel } from "types/orders";

export const deliveryOptions = [
  {
    label: OrderStatusLabel[OrderStatus.PENDING],
    value: OrderStatus.PENDING,
  },
  {
    label: OrderStatusLabel[OrderStatus.AUTO_FINALIZED],
    value: OrderStatus.AUTO_FINALIZED,
  },
  {
    label: OrderStatusLabel[OrderStatus.ACCEPTED],
    value: OrderStatus.ACCEPTED,
  },
  {
    label: OrderStatusLabel[OrderStatus.PREPARING],
    value: OrderStatus.PREPARING,
  },
  {
    label: OrderStatusLabel[OrderStatus.PREPARED],
    value: OrderStatus.PREPARED,
  },
  {
    label: OrderStatusLabel[OrderStatus.READY_FOR_PICKUP],
    value: OrderStatus.READY_FOR_PICKUP,
  },
  {
    label: OrderStatusLabel[OrderStatus.IN_DELIVERY],
    value: OrderStatus.IN_DELIVERY,
  },
  {
    label: OrderStatusLabel[OrderStatus.DELIVERED],
    value: OrderStatus.DELIVERED,
  },
  {
    label: OrderStatusLabel[OrderStatus.CANCELED],
    value: OrderStatus.CANCELED,
  },
];
